export default __webpack_public_path__ + "static/media/VALMEX_LOGO.7a7c7294.png";